import polygonClipping from 'polygon-clipping';
import { PointsPolygon } from './PointsPolygon.js';

// This class acts as a Facade for polygon-clipping library.
export class PolygonClippingFacade {
  // This method takes a Polygon instance that may be self-intersecting,
  // performs a union operation with itself, and returns a simplified polygon array.
  // Often the result is an array with one or more polygons (if the shape splits).
  static simplifyPolygon(polygon) {
    // Convert our polygon to polygon-clipping format
    const inputPolygon = polygon.toClippingFormat();

    // We do union of the polygon with itself
    let unionResult;
    let polygons = [];
    try {
      unionResult = polygonClipping.union(inputPolygon, inputPolygon);
      polygons = PointsPolygon.fromClippingFormat(unionResult);
    } catch (e) {
      //skip errors
    }

    if (!polygons.length) {
      return [];
    }

    // Return all polygons
    return polygons;
  }

  // This method calculates the area of a Polygon using the shoelace formula.
  static areaOfPolygon(polygon) {
    let area = 0;
    const pts = polygon.points;
    for (let i = 0; i < pts.length; i++) {
      const j = (i + 1) % pts.length;
      area += pts[i].x * pts[j].y - pts[j].x * pts[i].y;
    }
    return Math.abs(area) / 2;
  }

  // This method picks the polygon with the largest area from an array of polygons.
  static pickLargestPolygon(polygons) {
    let maxArea = -Infinity;
    let bestPoly = null;
    for (const poly of polygons) {
      const area = PolygonClippingFacade.areaOfPolygon(poly);
      if (area > maxArea) {
        maxArea = area;
        bestPoly = poly;
      }
    }
    return bestPoly;
  }
}
